import React, { useState } from 'react';
import '../../Default.css';
import './Schedule.css'
import { Calendar, Event } from './scheduleType';
import calendarData from './schedule.json'
const calendar: Calendar = calendarData as any;

function Shedule() {
  const [activeDayIndex, setActiveDayIndex] = useState(0 as number);
  const [isShowingDetailInfo, setIsShowingDetailInfo] = useState(false as boolean);
  const [activeEvent, setActiveEvent] = useState({} as Event);

  const showDetails = (eventIndex: number): void => {
    setActiveEvent(calendar.days[activeDayIndex].events[eventIndex]);
    setIsShowingDetailInfo(true);
  }

  const hideDetails = (): void => {
    setIsShowingDetailInfo(false);
  }

  return (
    <>
      <div className="page-title">
        Harmonogram
      </div>
      <div className='parapraf calendar-info'>
        W zależności od okoliczności od nas niezależnych mogą wystąpić zmiany w programie oraz w składzie artystów. Informacje będą przekazywane na bieżąco przez media społecznościowe oraz stronę internetową i Studio TV ŚDM.
      </div>
      <div className='calendar'>
        <div className='calendar-day-picker'>
          {calendar.days.map((day, index) =>
            <button 
              key={index} 
              type="button" 
              onClick={() => {hideDetails(); setActiveDayIndex(index)}}
              className={activeDayIndex === index ? 'active' : ''}
            >
              {day.day}
            </button>
          )}
        </div>
        <div className='calendar-day-timetable'>
          {isShowingDetailInfo
            ? 
              <div className='details-info'>
                <div className='calendar-day-event'>
                    <div className='calendar-day-event-name'>{activeEvent.name}</div>
                    <div className='calendar-day-event-range'>Wydarzenie {activeEvent.range}</div>
                    <div>Planowane rozpoczęcie: <b>{activeEvent.fromTime}</b></div>                    
                    <div>Planowane zakończenie: <b>{activeEvent.toTime}</b></div>
                    {activeEvent.contractor && <div className='calendar-day-event-contractor'>Wykonawcy: {activeEvent.contractor}</div>}
                    {activeEvent.lang && <div className='calendar-day-event-lang'>Język {activeEvent.lang}</div>}
                  </div>
                  <button onClick={() => hideDetails()}>wróć do pełnej listy</button>
              </div>        
            :
              <div>
                {calendar.days[activeDayIndex].events.map((event, index) =>
                  <div className='calendar-day-event' key={index} onClick={() => showDetails(index)}>
                    <div className='calendar-day-event-time'>{event.fromTime} - {event.toTime}</div>
                    <div className='calendar-day-event-name'>{event.name}</div>
                  </div>
                )}
              </div>    
          }
        </div>
      </div>
      
    </>
  );
}

export default Shedule;
